import axios from "axios";
import accessToken from "./jwt-token-access/accessToken";
import getLanguageId from "./jwt-token-access/languageId";
import toastr from "toastr";


toastr.options ={
  preventDuplicates : "false"
}

//apply base url for axios
const API_URL = "";

const axiosApi = axios.create({
  baseURL: API_URL,
});


axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  // const navigate = useNavigate();
  axiosApi.defaults.headers.common["Default-Lang"] = getLanguageId();
  axiosApi.defaults.headers.common["Authorization"] = accessToken();
  try {
    const response = await axiosApi.get(url, { ...config });
    return response.data
  } catch (error) {
    // if(error.response.data.message == "INVALID_TOKEN" || error.response.data.message == "NOT_AUTHORIZED"){
    //   window.location.href = "/"
    // }
    if(error.response.data.status_code == 401) {
      // window.location.href = "/"
      localStorage.removeItem("authUser");
      toastr.error(error.response.data.message)
    }
    return error?.response?.data

  }
}

export async function post(url, data, config = {}) {
  axiosApi.defaults.headers.common["Default-Lang"] = getLanguageId();
  axiosApi.defaults.headers.common["Authorization"] = accessToken();

  try {
    const response = await axiosApi.post(url, { ...data }, { ...config });
    return response.data
  } catch (error) {
    // if(error.response.data.message == "INVALID_TOKEN" || error.response.data.message == "NOT_AUTHORIZED"){
    //   window.location.href = "/"
    // }
    if(error.response.data.status_code == 401) {
      // window.location.href = "/"
      localStorage.removeItem("authUser");
      toastr.error(error.response.data.message) 
      
    }
    return error?.response?.data

  }
}
export async function postMulti(url, data, config = {}) {
  axiosApi.defaults.headers.common["Default-Lang"] = getLanguageId();
  axiosApi.defaults.headers.common["Authorization"] = accessToken();

  // Check if the data is a FormData object
  if (data instanceof FormData) {
    config.headers = {
      ...config.headers,
      "Content-Type": "multipart/form-data",
    };
  }

  try {
    const response = await axiosApi.post(url, data, config);
    return response.data;
  } catch (error) {
    // if (error.response?.data?.message === "INVALID_TOKEN" || error.response?.data?.message === "NOT_AUTHORIZED") {
    //   window.location.href = "/";
    // }

    if(error.response.data.status_code == 401) {
      // window.location.href = "/"
      localStorage.removeItem("authUser");
      toastr.error(error.response.data.message)
    }
    return error?.response?.data;
  }
}

export async function put(url, data, config = {}) {
  axiosApi.defaults.headers.common["Default-Lang"] = getLanguageId();
  axiosApi.defaults.headers.common["Authorization"] = accessToken();
  try {
    const response = await axiosApi.put(url, { ...data }, { ...config });
    return response.data
  } catch (error) {
    // if(error?.response?.data?.message == "INVALID_TOKEN" || error?.response?.data?.message == "NOT_AUTHORIZED"){
    //   window.location.href = "/"
    // }

    if(error.response.data.status_code == 401) {
      // window.location.href = "/"
      localStorage.removeItem("authUser");
      toastr.error(error.response.data.message)
    }
    return error?.response?.data
  }
}

export async function del(url, data, config = {}) {
  axiosApi.defaults.headers.common["Default-Lang"] = getLanguageId();
  axiosApi.defaults.headers.common["Authorization"] = accessToken();

  axiosApi.defaults.headers.common["Default-Lang"] = getLanguageId();
  axiosApi.defaults.headers.common["Authorization"] = accessToken();
  try {
    const response = await axiosApi.delete(url, { data: data }, { ...config });
    return response.data
  } catch (error) {
    // if(error.response.data.message == "INVALID_TOKEN" || error.response.data.message == "NOT_AUTHORIZED"){
    //   window.location.href = "/"
    // }

    if(error.response.data.status_code == 401) {
      // window.location.href = "/"
      localStorage.removeItem("authUser");
      toastr.error(error.response.data.message)
    }
    
    return error?.response?.data

  }

}
